<template>
  <v-tooltip bottom max-width="360">
    <template v-slot:activator="{ on, attrs }">
      <span
        class="payment-not-received-status"
        :class="{ 'payment-not-received-status--legend': legend }"
        v-bind="attrs"
        v-on="on"
      >
        <template v-if="legend">
          <v-icon size="20" color="#c62828" class="mr-1">mdi-cash-remove</v-icon>
          <span>{{ $t('dueDiligence.paymentRejected') }}</span>
        </template>
        <v-btn
          v-else
          small
          rounded
          :min-width="minWidth"
          depressed
          class="red-button"
          :height="height"
          tabindex="-1"
        >
          {{ $t('dueDiligence.paymentRejected') }}
        </v-btn>
      </span>
    </template>
    <span>{{ note }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'PaymentNotReceivedStatus',
  props: {
    item: {
      type: Object,
      default: null,
    },
    legend: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: 34,
    },
    minWidth: {
      type: [Number, String],
      default: 160,
    },
  },
  computed: {
    note() {
      const fromPayment = (this.item?.payment?.rejection_reason || '').trim();
      return fromPayment || this.$t('dueDiligence.paymentNotReceivedDefaultMessage');
    },
  },
};
</script>

<style scoped>
.payment-not-received-status {
  display: inline-block;
  cursor: help;
  pointer-events: auto;
}

.payment-not-received-status--legend {
  display: inline-flex;
  align-items: center;
}

.payment-not-received-status .red-button {
  pointer-events: none;
}
</style>
